import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class ClearUserCaches {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) {}

  run(user_id): Promise<{ [key: string]: string; }> {
    let args = {user_id:user_id}
    return this.dispatcher.dispatch('clear.all.user.caches', args)
  }
}